import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  apps: [],
  loading: true,
  tags: {
    data: {
      id: 0,
      name: "",
      parentId: null,
      metaData: null,
      createdAt: "",
      updatedAt: "",
      tags: [],
      children: [],
    },
    status: true,
  },
  currentApplicationId: "",
};

const unoApplicationSlice = createSlice({
  name: "unoApplicationSlice",
  initialState,
  reducers: {
    myApplicationList: (state, action) => {
      state.apps = action.payload;
    },
    myApplicationLoading: (state, action) => {
      state.loading = action.payload;
    },
    setTags: (state, action) => {
      state.tags = action.payload;
    },
    setCurrentApplicationId: (state, action) => {
      state.currentApplicationId = action.payload;
    },
  },
});

export const { myApplicationList, myApplicationLoading, setTags, setCurrentApplicationId } = unoApplicationSlice.actions;
export default unoApplicationSlice.reducer;
